import { Link } from "react-router-dom";
import usePageMeta from "@/hooks/usePageMeta";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import NewsHighlight from "@/pages/home/components/NewsHighlight";
import WorksPreview from "@/pages/home/components/WorksPreview";
import BrandIntro from "@/pages/home/components/BrandIntro";

export default function Home() {
  usePageMeta({
    title: "张津瑜 - 个人品牌官方网站与资讯中心",
    description:
      "张津瑜官方网站，提供最新的个人动态、作品展示以及专业资讯，连接粉丝与合作伙伴，打造全面的品牌形象。",
    keywords: "张津瑜,个人品牌,张津瑜资讯,张津瑜作品,张津瑜动态,品牌展示",
  });

  return (
    <>
      <HeroCarousel />
      <NewsHighlight />
      <WorksPreview />
      <BrandIntro />

      <section className="bg-background-100 py-14 md:py-20">
        <div className="mx-auto max-w-7xl px-4 md:px-6 lg:px-10">
          <div className="relative overflow-hidden rounded-lg bg-primary-800 px-6 py-12 md:px-12 md:py-16">
            <div className="absolute -right-10 -top-10 h-48 w-48 rounded-full bg-accent-500/20" />
            <div className="absolute -bottom-16 right-24 h-40 w-40 rounded-full bg-primary-500/30" />
            <div className="relative flex flex-col items-start gap-6 md:flex-row md:items-center md:justify-between">
              <div className="max-w-2xl">
                <h2 className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
                  期待与你的下一次合作
                </h2>
                <p className="mt-3 text-sm leading-relaxed text-background-300 md:text-base">
                  无论是品牌联名、内容共创，还是公益影像与分享活动，欢迎通过联系页面与我们取得联系。
                </p>
              </div>
              <Link
                to="/contact"
                className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-primary-950 transition-colors hover:bg-accent-400"
              >
                <i className="ri-mail-send-line text-base" />
                联系我们
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}